import * as React from 'react'
import Searchbar, { SearchbarProps } from '@components/form/searchbar'
import { SearchCategories } from '@webapp/store/categories/action-creators';
import { connect } from 'react-redux';
import AppState from '../../../store/state';
import { Dispatch } from 'redux';

export interface CategorySearchCtrlProps extends SearchbarProps<string> {
  service: string;
  search: (value: string) => SearchCategories
}

const mapStateToProps = (state: AppState, props: {service: string}) => ({
  results: (state.categories.results[props.service] || []).map((c) => c.name)
});

const mapDispatchToProps = (dispatch: Dispatch, props: {service: string}) => ({
  search: (value: string) => dispatch(new SearchCategories(props.service, value))
});

export const CategorySearchCtrl: React.FC<CategorySearchCtrlProps> = (props) => {
  return (
    <Searchbar {...props} />
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(CategorySearchCtrl);